<template>
  <div>
    <!-- 渲染表格 -->
    <BasicTable :isStyleApplied="isStyleApplied" searchPlaceholder="名称,运营人,执照,执照类型" :tableColumn="tableColumn" :tableData="tableData" :actions="actions" :showAddButton="this.uBtnPermissionList.includes('pilot-add')"
      :tableTitle="tableTitle" :showSearch="true" :current="current" :total="total" :size="size"
      @add-item="addItem" @detail-item="detailItem" @edit-item="editItem" @delete-item="deleteItem"
      @search-item="searchItem" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template #customCol>
        <el-table-column prop="sex" label="性别" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 0">男</span>
            <span v-else-if="scope.row.sex === 1">女</span>
          </template>
        </el-table-column>
      </template>
<!--      <template #extraBtn="scope" >-->
<!--        <el-button  v-if="uBtnPermissionList.includes('pilot-approve')&&scope.row.status==0" @click="approvalClick(scope.row)" type="text" size="small">审批</el-button>-->
<!--        &lt;!&ndash; 是否有驳回原因 &ndash;&gt;-->
<!--        <el-button  v-if="uBtnPermissionList.includes('pilot-reject')&&scope.row.status==0" @click="rejectClick(scope.row)" type="text" size="small">驳回</el-button>-->
<!--      </template>-->
<!--      <template #customCol>-->
<!--        <el-table-column prop="status" label="状态" align="center" min-width="60" :show-overflow-tooltip="true">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.status === 0">待审批</span>-->
<!--            <span v-if="scope.row.status === 1">已审批</span>-->
<!--            <span v-if="scope.row.status === 2">已驳回</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </template>-->
    </BasicTable>
    <BasicForm :isStyleApplied="isStyleApplied" :dialogVisible="dialogVisible" :dialogTitle="dialogTitle" :formModel="taskForm" :btnName="btnName"
      @submit="handleFormSubmit" @update:dialogVisible="updateDialogVisible" :formRules="formRules" ref="myRef">
      <!-- 正常写本页面需要的表单项 -->
      <el-col :span="12">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="taskForm.name" :disabled="ifView" placeholder="请填写姓名"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="年龄"
          prop="age"
          :rules="[{ required: true, message: '请填写年龄', trigger: 'blur' }, { validator: this.validateNumber, trigger: 'blur' }]"
        >
          <el-input v-model="taskForm.age" :disabled="ifView" placeholder="请填写年龄"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="性别" prop="sex">
          <el-select v-model="taskForm.sex" placeholder="请选择性别" popper-class="adminHomeSelect" :disabled="ifView">
            <el-option v-for="option in sexOptions" :key="option.id" :label="option.name"
              :value="option.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞手执照号" prop="license" :rules="handelType=='add'?licenseRules:handelType=='edit'&&isChangeLicense?licenseRules:[]">
          <el-input v-model="taskForm.license" :disabled="ifView" placeholder="请填写飞手执照号"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞手执照类型" prop="type">
          <el-input v-model="taskForm.type" :disabled="ifView" placeholder="请填写飞手执照类型"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="超视距等级" prop="bvlosLvl">
          <el-select v-model="taskForm.bvlosLvl" :disabled="ifView" placeholder="请选择超视距等级">
            <el-option v-for="item in bvlosLvls" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="类别等级" prop="typeLvl">
          <el-select v-model="taskForm.typeLvl" :disabled="ifView" placeholder="请选择类别等级">
            <el-option v-for="item in typeLvls" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="级别等级" prop="gradeLvl">
          <el-select v-model="taskForm.gradeLvl" :disabled="ifView" placeholder="请选择级别等级">
            <el-option v-for="item in gradeLvls" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人名称" prop="operatorId">
          <el-select
            v-model="taskForm.operatorId"
            :disabled="ifView"
            placeholder="请选择运营人名称"
            filterable
            clearable
          >
            <el-option
              v-for="item in operatorNames"
              :key="item.id"
              :label="item.operatorName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
<!--      <el-col :span="12">-->
<!--        <el-form-item label="用户账号" prop="userNo" >-->
<!--          <el-input v-model="taskForm.userNo" :disabled="ifView" auto-complete="off"-->
<!--                    placeholder="请填写用户账号(20字内,唯一)"-->
<!--                    maxlength="20"-->
<!--                    clearable ></el-input>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
      <el-col :span="12">
        <el-form-item
          label="执照图片"
          prop="pic"
          :rules="[
            { required: this.imgValid,  trigger: 'change',message: '请上传执照图片'}
          ]"
        >
          <el-upload class="upload-demo" action="#" :auto-upload="false" :show-file-list="false" accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG,"
            :on-change="handleElementPicChange" :disabled="ifView">
            <el-image :preview-src-list="dialogTitle == '查看' ? [imageUrl] : []" v-if="imageUrl" :src="imageUrl" class="uploaded-image" :title="imgTitle" />
            <div v-else class="upload-placeholder">
              <!-- <i class="el-icon-upload"></i> -->
              <div class="upload-text">
                <span>去上传</span>
              </div>
            </div>
          </el-upload>
        </el-form-item>
      </el-col>
    </BasicForm>

    <!-- 渲染弹框 -->
  </div>
</template>
<script type="text/javascript">
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";
import { deepCopy } from '@/utils/tools.js'
export default {
  props: {
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
  },
  name: "FlyDriver",
  // 注入公共组件
  components: {
    BasicTable, //公共表格
    BasicForm, //公共弹框
  },

  data() {
    return {
      //点击按钮类型
      handelType:'add',
      isChangeLicense:false,
      oldLicense:'',
      // ============表格配置信息==============
      // 列配置 label-列名，prop-对应列的字段名
      tableColumn: [
        { label: '姓名', prop: 'name' },
        { label: '年龄', prop: 'age' },
        // { label: '性别', prop: 'sex'},
        { label: '飞手执照', prop: 'license' },
        { label: '飞手执照类型', prop: 'type' },
        { label: '超视距等级', prop: 'bvlosLvlName' },
        { label: '类别等级', prop: 'typeLvlName' },
        { label: '级别等级', prop: 'gradeLvlName' },
        { label: '运营人名称', prop: 'operatorName' },
        // {label:'执照照片', prop: 'licensePhotoUrl'},
        // { label: '状态3', prop: 'status' },
        // { label: '姓名2', prop: 'name' },
        // { label: '姓名3', prop: 'name' },
      ],
      tableData: [], // 列表内容数据
      actions: [],
      showAddButton: true, //是否展示新增按钮
      tableTitle: '飞手管理', //表格标题

      // ===========表单配置信息===============
      dialogVisible: false, //初始不展示对话框
      dialogTitle: '', //表单标题
      btnName: '', //表单提交按钮名字
      taskForm: {
        name: '',
        license: '',
        type: '',
        gradeLvl: '',
        typeLvl: '',
        bvlosLvl: '',
        file: '',
        age: '',
        sex: '',
        operatorId: '',
      }, // 表单数据绑定
      ifView: '',//是否为查看状态
      imageUrl: '',
      showTooltip: false, // 控制提示文字显示与隐藏
      gradeLvls: [], //级别等级下拉框数据
      typeLvls: [], //类别等级下拉框数据
      bvlosLvls: [], //超视距等级下拉框数据
      isEdit: false,
      sexOptions: [
        { id: 0, name: "男" },
        { id: 1, name: "女" },
      ],
      imgTitle: '',
      // 定义表单必填校验
      formRules: [
        { label: '姓名', prop: 'name' },
        // { label: '年龄', prop: 'age' },
        { label: '性别', prop: 'sex' },
        // { label: '用户账号', prop: 'userNo' },
        // { label: '飞手执照号', prop: 'license' },
        { label: '飞手执照类型', prop: 'type' },
        { label: '级别等级', prop: 'gradeLvl' },
        { label: '类别等级', prop: 'typeLvl' },
        { label: '超视距等级', prop: 'bvlosLvl' },
        { label: '运营人名称', prop: 'operatorId' },
      ],
      licenseRules: [{ required: true, message: '请填写飞手执照号', trigger: 'change' }],

      imgValid: true, // 校验图片
      total: 0, //总条数
      current: 1, //当前页数
      size: 18, //显示几条
      searchKey: '', //搜索关键字
      operatorNames: [], //运营人名称
    };
  },
  watch: {
    imageUrl(newVal, oldVal) {
      // console.log('new-->',newVal,'old-->',oldVal)
      if (newVal !== '') {
        this.imgValid = false;
      } else {
        this.imgValid = true;
      }
    },
    "taskForm.license":{
      handler(v){
        if(v!== this.oldLicense){
          this.isChangeLicense = true
        }
      }
    },
  },
  mounted() {
      this.uBtnPermissionList.includes('pilot-check')&&this.actions.push({ label: "查看", type: "view" })
      this.uBtnPermissionList.includes('pilot-modify')&&this.actions.push({ label: "修改", type: "edit" })
      this.uBtnPermissionList.includes('pilot-delete')&&this.actions.push({ label: "删除", type: "delete" })
      // 请求表格配置和数据
      this.getTable()
  },
  computed: {
    uBtnPermissionList() {
      return  this.getPageBtnRole('pilotsManagement')||[]
    },
  },
  created() {
    this.getGradeLvls();
    this.getBvlosLvls();
    this.getTypeLvls();
  },
  methods: {
    approvalClick(v){
      this.dialogVisible = true;
      this.dialogTitle = "飞手审批";
      this.btnName = "审批";
      this.ifView = true; //仅查看，不可编辑
      this.taskForm = { ...v };
      this.imageUrl = "/minio/" + v.licensePhotoUrl;
      this.ifView = true
    },
    rejectClick(v){
      this.$confirm("是否确认驳回", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: '取消',
        type: "warning"
      }).then(()=>{
        this.getRequest(
          "/user-server/Flydriver/refuseById?id=" + v.id,
        ).then((res)=>{
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 成功后刷新
            this.getTable()
          }else {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        })
      })
    },
    // 关闭对话框时获取子组件传过来的dialogVisible状态
    updateDialogVisible(newVal) {
      this.dialogVisible = newVal;
      this.handelType = 'add'
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.getTable();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.getTable();
    },
    getTable() {
      this.getRequest("/user-server/Flydriver/queryAllFlyDriver?current="+ this.current + "&size=" + this.size + "&keyword=" + this.searchKey)
      .then(
        (res) => {
          let oData = res.data;
          if (0 == oData.code) {
            if (oData.data) {
              this.tableData = oData.data.records;
              this.total = oData.data.total;
              this.size = oData.data.size;
              this.current = oData.data.current;
            } else {
              this.tableData = [];
            }
          }
        }
      );
    },

    addItem() {
      this.dialogVisible = true
      this.dialogTitle = '新增';
      this.btnName = '提交'; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.imageUrl = '';
      this.resetForm();
      this.getOperatorName();
    },
    // 重置表单
    resetForm() {
      this.taskForm = {
        name: '',
        license: '',
        type: '',
        gradeLvl: '',
        typeLvl: '',
        bvlosLvl: '',
        file: '',
        operatorId: '',
      };
    },
    // 查看
    detailItem(item) {
      this.handelType = 'view'
      this.dialogVisible = true
      this.dialogTitle = '查看';
      this.btnName = '关闭';
      this.ifView = true; //仅查看，不可编辑
      this.taskForm = { ...item };
      this.imageUrl = "/minio/" + item.licensePhotoUrl;
      this.imgTitle = '';
      this.getOperatorName();
    },
    // 修改 TODO
    editItem(item) {
      this.oldLicense = item.license
      this.isChangeLicense = false
      this.handelType = 'edit'
      this.dialogVisible = true
      this.dialogTitle = '修改';
      this.btnName = '提交'; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      this.imageUrl = "/minio/" + item.licensePhotoUrl;
      this.taskForm = { ...item };
      this.imgTitle = '单击图片可修改';
      this.getOperatorName();
    },
    // 删除 TODO--
    async deleteItem(itemId) {
      try {
        this.deleteRequest(
          "/user-server/Flydriver/deleteFlyDriverById?id=" + itemId
        ).then((res) => {
           const oData = res.data;
          if  (0 == oData.code) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 成功后刷新
            this.getTable()
          } else {  
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        });
      } catch (error) {
        console.error("删除失败", error);
      }
    },
    // async deleteItem(itemId) {
    //   try {
    //     // 发起删除请求
    //     // console.log("进入删除" + itemId);
    //     this.delete(itemId);
    //     this.tableData = this.tableData.filter(item => item.id !== itemId);
    //     console.log('删除成功', itemId);
    //     this.$nextTick(function () {
    //       this.getTable();
    //     });
    //   } catch (error) {
    //     console.error('删除失败', error);
    //   }
    // },

    getGradeLvls() {
      this.getRequest("/user-server/Flydriver/getGradeLvl").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              this.gradeLvls = data;
            }
          }
        }
      );
    },
    getTypeLvls() {
      this.getRequest("/user-server/Flydriver/getTypeLvl").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              this.typeLvls = data;
            }
          }
        }
      );
    },
    getBvlosLvls() {
      this.getRequest("/user-server/Flydriver/getBvlosLvl").then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            let data = oData.data;
            if (data) {
              this.bvlosLvls = data;
            }
          }
        }
      );
    },
    // 点击确认
    async handleFormSubmit(formData) {
      if (this.dialogTitle === '新增') {
        // 执行新增操作 请求后端接口
        this.insertFlyDriver(formData);
        // this.tableData.unshift({
        //   ...formData
        // });
      } else if (this.dialogTitle === '修改') {
        this.updateFlyDriver(formData);
      } else if (this.dialogTitle === '查看') {
        // 执行查看操作
      }else if(this.dialogTitle === "飞手审批"){
        this.getRequest(
          "/user-server/Flydriver/approveById?id=" + formData.id,
        ).then((res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            // 修改成功后刷新
            this.getTable()
          }else {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        });
      }
      this.dialogVisible = false
      this.handelType = 'add'
    },
    insertFlyDriver(formData) {
      let vue = this;
      const multiData = this.formatSubmitData(deepCopy(formData));
      this.postJsonRequest("/user-server/Flydriver/addFlyDriver", multiData).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            this.getTable();
          } else if (oData.code != 401) {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        }
      );
    },

    updateFlyDriver(formData) {
      if(!this.isChangeLicense){
        formData.license =''
      }
      let vue = this;
      delete formData.updatedTime;
      const multiData = this.formatSubmitData(deepCopy(formData));
      this.putJsonRequest("/user-server/Flydriver/updateFlyDriver", multiData).then(
        (res) => {
          let oData = res.data;
          if (oData.code === 0) {
            this.$message.success({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () {
              },
            });
            this.getTable();
          } else if (oData.code != 401) {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () {
              }
            });
          }
        }
      );
    },

    formatSubmitData(commonForms) {
      const formData = new FormData();
      const commonForm = commonForms;
      for (const key in commonForm) {
        if (commonForm.hasOwnProperty(key)) {
          const element = commonForm[key];
          if (null != element && 0 < (element + "").trim().length) {
            formData.append(key, element);
          }
        }
      }
      return formData;
    },

    // 上传图元图片改变时执行的事件
    handleElementPicChange(file) {
      const isJPGPNG = file.type === 'image/jpeg' || 'image/png';
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isJPGPNG) {
        let tips = "<i class='el-icon-warn-tip'></i>" + '上传图元图片只能是 JPG 或 png 格式!';
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }
      if (!isLt1M) {
        let tips = "<i class='el-icon-warn-tip'></i>" + '上传图元图片大小不能超过 1MB!';
        this.$confirm(tips, "提示", {
          confirmButtonText: "好的",
          customClass: "customClass-style",
          iconClass: "",
          dangerouslyUseHTMLString: true,
          confirmButtonClass: "confirm-style",
          showCancelButton: false,
        });
      }

      if (isJPGPNG && isLt1M) {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.taskForm.file = file.raw;
        this.$nextTick(() => {
          this.$refs.myRef.$refs.formRef.clearValidate('pic'); // 清除校验
        });
      }
    },

    // delete(id) {
    //   this.deleteRequest("/user-server/Flydriver/deleteFlyDriverById?id=" + id).then(
    //     (res) => {
    //       // let oData = res.data;
    //       // if (oData.code == 0) {
    //       //   this.$message({
    //       //     // message: "删除成功",
    //       //     // duration: 1000,
    //       //     // customClass: "message-s",
    //       //     // offset: 470,
    //       //     // onClose: function () {},
    //       //   });
    //       // } else if (oData.code != 401) {
    //       //   let tips = "<i class='el-icon-warn-tip'></i>" + oData.data;
    //       //   this.$confirm(tips, "提示", {
    //       //     confirmButtonText: "好的",
    //       //     customClass: "customClass-style",
    //       //     iconClass: "",
    //       //     dangerouslyUseHTMLString: true,
    //       //     confirmButtonClass: "confirm-style",
    //       //     showCancelButton: false,
    //       //   });
    //       // }
    //     }
    //   );
    // },
    searchItem(val) {
      //模糊搜索
      // console.log(val);
      this.searchKey = val;
      this.getTable();
    },
    // 数字校验
    validateNumber(rule, value, callback) {
      if (value === '' || !/^\d+$/.test(value)) {
        callback(new Error('请填写有效的数字'));
      } else {
        callback();
      }
    },
    // 获取运营人
    getOperatorName() {
      this.getRequest(
        "/user-server/Operator/queryCoperatorByOperatorName"
      )
        .then(res => {
          let oData = res.data;
          if (0 == oData.code) {
            let nameDataList = oData.data;
            // console.log("运营人名称-->", nameDataList);
            this.operatorNames = nameDataList;
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch(error => {});
    },
  },
};
</script>

<style scoped>
.upload-demo {
  width: 120px;
  height: 120px;
  /* border: 1px solid #1D6DC8; */
  background: rgba(1,10,18,0.68);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
>>> .el-form-item__label{
  width: 140px !important;
  text-align: right;
}
.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
>>>.el-dialog__header {
    /* background-image: url(../../img/common/tableHead.png); */
    /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
    padding: 20px 20px 0px 40px ;
    background: url(../../assets/img/2dmap/pop_bg.png)  no-repeat;
    background-position: 18px 25px;
}
.upload-placeholder .el-icon-upload {
  font-size: 32px;
}

.upload-placeholder .upload-text {
  /* margin-top: 8px; */
  font-size: 16px;
font-family: Adobe Heiti Std, Adobe Heiti Std-R;
font-weight: normal;
text-align: left;
color: #00aeff;
}

.uploaded-image {
  width: 120px;
  height: 120px;
  object-fit: contain;   /* 保持比例，完整显示，可能有空白 */
  display: flex;        /* 移除底部间隙 */
}
.uploaded-image >>> .el-image__inner {
  max-height: 100% !important;
  max-width: 100% !important;
  object-fit: contain !important;
  height: auto !important; /* 重置默认height */
}

</style>



// WEBPACK FOOTER //
// src/components/home/FlyDriver.vue